import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EstensaNotificationService } from '../../../services/angularjs/estensa-notification.service';
import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';
import { INotification, IVNextNotification, NotificationService, NotificationType } from '../../../services/notification.service';


@Component({
    selector: 'se-header-notification',
    templateUrl: './se-header-notification.component.html',
    styleUrls: ['./se-header-notification.component.scss'],
    animations: [
        trigger('errorAnimation', [
            state('open', style({
                color: '#c62828'
            })),
            state('closed', style({
                color: 'white'
            })),
            transition('open => closed', [
                animate('0.3s')
            ]),
            transition('closed => open', [
                animate('0.7s')
            ]),
        ]),
    ],
    standalone: false
})
export class SeHeaderNotificationComponent implements OnDestroy, OnInit {

    private notificationSubscriber = null;
    private animationCounter = 0;

    isOpen: boolean = false;

    get vnextNotifications(): IVNextNotification[] {
        return this.notificationService.vnextNotifications;
    }

    constructor(private translateService: TranslateService,
        private notificationService: NotificationService,
        private ngNotificationService: EstensaNotificationService) { }


    ngOnDestroy() {
        this.notificationSubscriber.unsubscribe();

        // this.setInfoMessagesAsRead(); Al cambio di pagina si sceglie di mantenere anche le notifiche
    }

    ngOnInit() {
        this.removeOldMessages(false);

        this.notificationSubscriber = this.notificationService
            .notification
            .subscribe((notification: INotification) => {
                // Inserisco solo messaggi che non sono duplicati (e non sono errori in quel caso li inserisco lo stesso), in caso rimuovo e reinserisco
                const lastNotification = this.notificationService.vnextNotifications[0];
                if (this.notificationService.vnextNotifications.length <= 0 ||
                    lastNotification.message != notification.message ||
                    lastNotification.type != notification.type ||
                    notification.type == NotificationType.error)
                    this.unshiftNotification(notification);
                else if (!!!lastNotification.count)
                    lastNotification.count = 2;
                else
                    lastNotification.count++;

            });
    }


    unshiftNotification = (notification: INotification) => {
        const newNotification: IVNextNotification = notification as IVNextNotification;
        let ngMessage = "";
        switch (newNotification.type) {
            case NotificationType.error:
                const errorMessage = this.translateService.instant('Error');

                // Animazione icona campanello
                if (this.animationCounter == 0) {
                    this.isOpen = true;
                    this.animationCounter++;
                }

                if (!newNotification.title) { // Se non c'è titolo, promuovo il message a status di titolo.
                    newNotification.title = newNotification.message;
                    newNotification.message = '';
                }

                // Vecchio popup colorato in basso a dx - se il titolo non è 'error', 'warning' o 'info' uso quello, altrimenti uso il message di dettaglio
                ngMessage = (newNotification.title != errorMessage) ? newNotification.title : notification.message;
                if (ngMessage != errorMessage) // se anche il message di dettaglio è 'error', 'warning' e 'info' lascio stare
                    this.ngNotificationService.error(ngMessage);
                break;
            case NotificationType.warning:
                const warningMessage = this.translateService.instant('Warning');
                if (!newNotification.title) { // Se non c'è titolo, promuovo il message a status di titolo.
                    newNotification.title = newNotification.message;
                    newNotification.message = '';
                }

                // Vecchio popup colorato in basso a dx - se il titolo non è 'error', 'warning' o 'info' uso quello, altrimenti uso il message di dettaglio
                ngMessage = (newNotification.title != warningMessage) ? newNotification.title : notification.message;
                if (ngMessage != warningMessage) // se anche il message di dettaglio è 'error', 'warning' e 'info' lascio stare
                    this.ngNotificationService.warning(ngMessage);
                break;
            default:
                const infoMessage = this.translateService.instant('Info');
                if (!newNotification.title) { // Se non c'è titolo, promuovo il message a status di titolo.
                    newNotification.title = newNotification.message;
                    newNotification.message = '';
                }

                // Vecchio popup colorato in basso a dx - se il titolo non è 'error', 'warning' o 'info' uso quello, altrimenti uso il message di dettaglio
                ngMessage = (newNotification.title != infoMessage) ? newNotification.title : notification.message;
                if (ngMessage != infoMessage) // se anche il message di dettaglio è 'error', 'warning' e 'info' lascio stare
                    this.ngNotificationService.success(ngMessage);
        }


        const now = new Date();
        newNotification.time = now.toLocaleTimeString();
        this.notificationService.vnextNotifications.unshift(newNotification);
    }

    onErrorAnimationDone() {
        if (this.animationCounter > 0 && this.animationCounter < 10) {
            this.isOpen = !this.isOpen;
            this.animationCounter++;
        }
        else if (this.animationCounter >= 10 && this.isOpen) {
            this.isOpen = false;
            this.animationCounter++;
        }
        else if (this.animationCounter >= 10 && !this.isOpen)
            this.animationCounter = 0;
    }

    onClick = (e) => {
        e.cancelBubble = true; //blocco chiusura della popup
    }

    getActiveMessageNumber = () => {
        const messageNumber = this.notificationService.vnextNotifications.filter(notification => (!!!notification.timeShown && !notification.wasShown)).length;
        if (messageNumber > 0)
            return messageNumber;

        return '';
    }

    areActiveMessagesPresent = (): boolean => {
        return this.getActiveMessageNumber() != '';
    }

    getTotalMessageNumber = () => {
        const messageNumber = this.notificationService.vnextNotifications.length;
        if (messageNumber > 0)
            return messageNumber;

        return '';
    }

    onMenuOpened = () => {
        this.animationCounter = 10;
        this.isOpen = false;

        this.removeOldMessages();
    }

    onMenuClosed = () => {
        this.notificationService.vnextNotifications.forEach(notification => notification.wasShown = true);
    }

    getBadgeColor = () => {
        let color = 'primary';
        let keepGoing = true;
        this.notificationService.vnextNotifications.forEach(notification => {
            if (!notification.wasShown &&  keepGoing) {
                switch (notification.type) {
                    case NotificationType.warning:
                        color = 'warn';
                        break;
                    case NotificationType.error:
                        color = 'error';
                        keepGoing = false;
                        break;
                }
            }
        });

        return color;
    }

    private removeOldMessages(setTimeShown: boolean = true) {
        const now = Date.now();
        this.notificationService.vnextNotifications = this.notificationService.vnextNotifications.filter((notification) => {
            if (!notification.timeShown) {
                if (setTimeShown)
                    notification.timeShown = now;
                return true;
            }
            else {
                const elapsed = now - notification.timeShown; // time in milliseconds*/

                // Per tutti i tipi di notifiche mettiamo 5 minuti
                return (elapsed < 300000); //5m;
            }
        });
    }
}
